export default {
  GET_TABLES_BY_CAFE_ID_LOADING: 'GET_TABLES_BY_CAFE_ID_LOADING',
  GET_TABLES_BY_CAFE_ID_REJECT: 'GET_TABLES_BY_CAFE_ID_REJECT',
  GET_TABLES_BY_CAFE_ID_FAILED: 'GET_TABLES_BY_CAFE_ID_FAILED',
  GET_TABLES_BY_CAFE_ID_SUCCESS: 'GET_TABLES_BY_CAFE_ID_SUCCESS',
  CLEAR_CAFE_TABLES_LIST_DATA: 'CLEAR_CAFE_TABLES_LIST_DATA'
};
